import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import '../../css/LoginForm.css';
import Select from 'react-select';
import '../../prelogin/public/css/react-select.css';

class StudentDropdown extends PreLoginPage {
	constructor(props) {
		super(props);
		
		this.state = {				
				selectedStudentOption:this.props.studentDpList[0],
				studentDpList:this.props.studentDpList
		}
		
		this.studentDropdownChange = this.studentDropdownChange.bind(this);
		this.resetDropdowns = this.resetDropdowns.bind(this);
		
	}	
	resetDropdowns(){
		//this.setState({selectedStudentOption:this.state.studentDpList[0]});
		this.state.selectedStudentOption = this.props.studentDpList[0];
		this.setState(this.state);		
	}
	componentWillReceiveProps(){
		this.setState({studentDpList:this.props.studentDpList});
	}
	studentDropdownChange(selectedOption){
		this.setState({selectedStudentOption:selectedOption});
		this.props.callBackParentStudentDdChange(selectedOption,this.props.index);
	}
		
	render() {
		return (
				<div className="infoTxt">
    				{this.rb("product.assignedto")}: 
    				<span className="minwid-200 selectbox">
						<Select						        
					        value={this.state.selectedStudentOption}
					        onChange={this.studentDropdownChange}
					        options={this.state.studentDpList}						    		    						
						 	onBlurResetsInput={false}
							onSelectResetsInput={false}															 	
						 	clearable={false}
						 	rtl={false}
						 	searchable={false}
					      />
					</span>
    			</div>
		);
	}
}

export default StudentDropdown;


// WEBPACK FOOTER //
// ./src/views/purchase/StudentDropdown.js